import { coordinateToChartTime, chartTimeToCoordinate } from '../../../lib/chart/chartTimeProjection.js'
// Snap in screen space so 45 degrees means the visible angle, regardless of
// price range or zoom. Re-project the native bar time to keep diagonal slopes
// exact even when coordinateToTime rounds to a neighboring close.
export function snapTrendlinePoint(api, anchor, target) {
  const x = chartTimeToCoordinate(api.chart, api.series, anchor.time, api.timeframe), y = api.series.priceToCoordinate(anchor.price)
  if (x == null || y == null) return null
  const dx = target.x - x, dy = target.y - y
  const angle = Math.round(Math.atan2(dy, dx) / (Math.PI / 4)) * Math.PI / 4
  const length = Math.hypot(dx, dy)
  const horizontal = Math.abs(Math.sin(angle)) < 1e-6
  const vertical = Math.abs(Math.cos(angle)) < 1e-6
  if (vertical) {
    const price = api.series.coordinateToPrice(y + Math.sign(dy) * length)
    return Number.isFinite(price) ? { time: anchor.time, price } : null
  }
  const time = coordinateToChartTime(api.chart, api.series, x + Math.cos(angle) * length, api.timeframe)
  if (!Number.isFinite(time)) return null
  const snappedX = chartTimeToCoordinate(api.chart, api.series, time, api.timeframe)
  if (snappedX == null) return null
  const price = horizontal ? anchor.price : api.series.coordinateToPrice(y + Math.sign(dy) * Math.abs(snappedX - x))
  return Number.isFinite(price) ? { time, price } : null
}
